import { Store } from "vuex";
import { namespace as contentItemsnamespace } from "../modules/contentItems/contentItems";
import { ContentItem, ContentItemFieldValue, Controllers } from "@infoland/iprova-api";
import { ContentItemsRequest } from "../../types/ContentItemsRequest";
import { ContentItemDetails } from "@/types/contentItemDetails";
import { namespace as contentItemsFiltersNamespace } from "../modules/contentItems/contentItemsFilters";

export class ContentItemStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the content items list  */
    public get currentRecentContentItems(): ContentItem[] {
        return this.store.getters[`${contentItemsnamespace}/recentContentItems`];
    }
    /** Gets the current searched content items */
    public get currentContentItems(): ContentItem[] {
        return this.store.getters[`${contentItemsnamespace}/contentItems`];
    }

    /** Gets the fill out content items */
    public get currentFillOutContentItems(): ContentItem[] {
        return this.store.getters[`${contentItemsnamespace}/fillOutContentItems`];
    }
    /** Gets the number of content items for browse */
    public get numberOfAvailableContentItems(): number {
        return this.store.getters[`${contentItemsnamespace}/numberOfAvailableContentItems`];
    }
    /** Gets the fill out content items total number */
    public get totalNumberOffillOutContentItem(): number {
        return this.store.getters[`${contentItemsnamespace}/totalNumberOfFillOutContentItems`];
    }
    /** Gets the search suggestion correction */
    public get searchSuggestionCorrection(): string {
        return this.store.getters[`${contentItemsnamespace}/searchSuggestionCorrection`];
    }

    /** Gets the total number of content items available for creating hyperlink */
    public get numberOfAvailableContentItemsForHyperlink(): number {
        return this.store.getters[`${contentItemsnamespace}/numberOfAvailableContentItemsForHyperlink`];
    }

    /** Loads the recent content items list */
    public async loadRecentContentItemsAsync(portalId: number, text_contains: string): Promise<ContentItem[]> {
        return this.store.dispatch(`${contentItemsnamespace}/loadRecentContentItemsAsync`, { portalId, text_contains });
    }

    /** Search the content items by search criterias */
    public async loadContentItemsAsync(searchParams: ContentItemsRequest): Promise<{ items: ContentItem[]; filterId: string }> {
        return this.store.dispatch(`${contentItemsnamespace}/loadContentItemsAsync`, searchParams);
    }

    /** Loads the fill out content items */
    public async loadFillOutContentItemsAsync(text_contains: string, portal_id: number, limit: number, offset: number): Promise<ContentItem[]> {
        return this.store.dispatch(`${contentItemsnamespace}/loadFillOutContentItemsAsync`, { text_contains, portal_id, limit, offset });
    }

    /** Gets the content items details  */
    public async loadContentItemDetailsAsync(contentItemDetails: ContentItemDetails): Promise<ContentItemFieldValue[]> {
        return this.store.dispatch(`${contentItemsnamespace}/loadContentItemDetailsAsync`, contentItemDetails);
    }

    /** Gets the content items available for hyperlinks */
    public async getContentItemsForHyperlinkAsync(searchParams: ContentItemsRequest): Promise<ContentItem[]> {
        return this.store.dispatch(`${contentItemsnamespace}/getContentItemsForHyperlinkAsync`, searchParams);
    }

    /** Sets the option to get a search correction from server when calling for content items  */
    public setIncludeSearchSuggestionCorrection(includeSearchSuggestionCorrection: boolean): void {
        this.store.dispatch(`${contentItemsnamespace}/setIncludeSearchSuggestionCorrection`, includeSearchSuggestionCorrection);
    }

    /** Check if portal has (fillable) content items  */
    public async getHasContentItemsAsync(portalId: number, fillable?: boolean, show_on_management_info_page?: boolean): Promise<boolean> {
        let url: string;
        if (portalId) url = `portals/${portalId}/content_items?limit=1`;
        else url = "portals/content_items?limit=1";

        if (typeof fillable === "boolean") {
            url += `&fillable=${fillable}`;
        }

        if (typeof show_on_management_info_page === "boolean") {
            url += `&show_on_management_info_page=${show_on_management_info_page}`;
        }

        const response: ContentItem[] = await Controllers.GenericController.getAsync<ContentItem[]>(url);
        return response?.length > 0;
    }

    public reset(): void {
        this.store.commit(`${contentItemsnamespace}/reset`);
        this.store.commit(`${contentItemsFiltersNamespace}/reset`);
    }
}
